import { motion } from 'framer-motion'

const IPhoneMockup = ({ videoSrc }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="relative mx-auto w-[220px] md:w-[260px] lg:w-[280px]"
    >
      <div
        className="relative rounded-[44px] overflow-hidden bg-[#1a1a1a] p-[8px] ring-1 ring-white/10"
        style={{ boxShadow: '0 25px 50px rgba(0, 0, 0, 0.4), 0 0 0 2px #333' }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 z-30 w-[140px] h-[30px] bg-black rounded-b-[20px] flex items-center justify-center gap-3">
          <div className="w-10 h-1 bg-[#222] rounded-full" />
          <div className="w-2 h-2 bg-[#0d1321] rounded-full ring-1 ring-white/5" />
        </div>

        <div
          className="relative rounded-[36px] overflow-hidden bg-black"
          style={{ aspectRatio: '9 / 19.5' }}
        >
          <video
            aria-label="Demonstração do aplicativo no iPhone"
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>

        <div className="absolute bottom-[14px] left-1/2 -translate-x-1/2 z-20 w-[100px] h-[4px] bg-white/30 rounded-full" />
      </div>

      <div
        className="absolute -inset-8 -z-10 rounded-full opacity-20 blur-[60px]"
        style={{ background: 'radial-gradient(circle, #007AFF 0%, transparent 70%)' }}
      />
    </motion.div>
  )
}

export default IPhoneMockup
